import { formatDate } from '@angular/common';
import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { combineLatest, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Entity } from '../classes/entity.class';
import { PlanningHasEntity } from '../classes/planning-has-entity.class';
import { UserPlanning } from '../classes/user-planning';
import { User } from '../classes/user.class';
import { PlanningHasService } from '../services/planning/planning-has.service';
import { UserPlanningService } from '../services/planning/user-planning.service';
import { Utils } from '../utils.class';

export const localEmployeeAvailableValidator = (
    userPlanningService?: UserPlanningService,
    planningHasService?: PlanningHasService,
    skipUserPlanning?: UserPlanning,
    planningId?: number,
    currentFormPlanningHas?: () => Pick<PlanningHasEntity, 'id' | 'driver_user_id' | 'begindate' | 'enddate'>[],
    currentFormUserPlanning?: () => Pick<UserPlanning, 'id' | 'user_id' | 'begindate' | 'enddate'>[]
) => {
    return (
        formGroup: FormGroup<
            ControlsOf<{
                id: number;
                conflictText: string;
                begindate: number;
                enddate: number;
                user_id: number;
            }>
        >
    ) => {
        if (formGroup?.value.begindate && formGroup?.value.enddate && formGroup?.value.user_id) {
            const begindate = Utils.getTimeOrNull(formGroup?.value.begindate as any as Date);
            const enddate = Utils.getTimeOrNull(formGroup?.value.enddate as any as Date);
            let res = false;
            return combineLatest([
                userPlanningService.getFilteredList(
                    Utils.newDate(formGroup?.value.begindate),
                    Utils.newDate(formGroup?.value.enddate)
                ),
                planningHasService.getFilteredList(
                    Utils.newDate(formGroup?.value.begindate),
                    Utils.newDate(formGroup?.value.enddate)
                ),
            ]).pipe(
                first(),
                map(([userPlannings, planningHass]) => {
                    let text = `De inplanning conflicteert met:\n `;
                    const makeText = (userPlanning: {
                        begindate: Date;
                        enddate: Date;
                        planning?: { afas_project_id?: string };
                        afas_project_id?: string;
                        entity?: Entity;
                        user?: User;
                    }) => {
                        const from = formatDate(userPlanning.begindate, 'HH:mm', 'nl');
                        const to = formatDate(userPlanning.enddate, 'HH:mm', 'nl');
                        const entity = userPlanning?.entity?.name
                            ? ` (${userPlanning.entity.name})`
                            : userPlanning.user
                              ? ` (${userPlanning.user.name})`
                              : '';
                        return `Project ${userPlanning?.planning?.afas_project_id ?? userPlanning?.afas_project_id}${entity} van ${from} tot ${to}`;
                    };

                    [
                        ...planningHass.filter(ph => ph?.planning_id !== planningId),
                        ...(currentFormPlanningHas ? currentFormPlanningHas() : []),
                    ].forEach(planningHas => {
                        if (planningHas.driver_user_id === formGroup?.value.user_id) {
                            if (
                                Utils.getTimeOrNull(planningHas.begindate) < enddate &&
                                Utils.getTimeOrNull(planningHas.enddate) > begindate
                            ) {
                                res = true;
                                text += makeText(planningHas);
                            }
                        }
                    });

                    [
                        ...userPlannings.filter(up => up?.planning_id !== planningId),
                        ...(currentFormUserPlanning ? currentFormUserPlanning() : []),
                    ]
                        .filter(up => !!up?.id && skipUserPlanning?.id !== up?.id)
                        .forEach(userPlanning => {
                            if (userPlanning.id !== formGroup.value.id) {
                                if (userPlanning.user_id === formGroup.value.user_id) {
                                    if (
                                        Utils.getTimeOrNull(userPlanning.begindate) < enddate &&
                                        Utils.getTimeOrNull(userPlanning.enddate) > begindate
                                    ) {
                                        res = true;
                                        text += makeText(userPlanning);
                                    }
                                }
                            }
                        });

                    formGroup.controls.conflictText.setValue(res ? text : null, { emitEvent: false, onlySelf: true });

                    return res ? { notAvailable: res } : null;
                })
            );
        }
        return of(null);
    };
};
